<template>
    <div class="float_btn">
        <a @click="fbShare" target="_blank">
            <img :src="require(`@/assets/images/icon/fb-icon.png`)">
        </a>
    </div>
</template>

<script>
    export default {
        name: 'FloatBtn',
        
        methods: {
            fbShare() {
                var origin_url = window.location.origin + '/events/2018xmas/';
                // var origin_url = window.location.origin;

                console.log(origin_url)
                if (this.isLineApp()) {
                    this.AppShare();
                } else if (this.isFacebookApp() != true) {
                    this.AppShare();
                } else {
                    FB.ui({
                        method: 'share',
                        href: origin_url,
                        redirect_uri: origin_url
                    }, function (response) {
                        location.href = origin_url
                    });
                }
            },
            AppShare() {
                var origin_url = window.location.origin + '/events/2018xmas/';
                // var origin_url = window.location.origin;

                var href = encodeURIComponent(origin_url);
                var redirect_url = encodeURIComponent(origin_url);
                location.href = "https://www.facebook.com/dialog/share?app_id=1588003457929939&display=popup&href=" +
                    href + "&redirect_uri=" + redirect_url;
            },
            isFacebookApp() {
                var ua = navigator.userAgent || navigator.vendor || window.opera;
                return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
            },
            isLineApp() {
                var ua = navigator.userAgent || navigator.vendor || window.opera;
                return (ua.indexOf("Line") > -1);
            }
        },
    }
</script>